"use client";

import { useCallback } from "react";
import { Filter as FilterIcon } from "react-iconly";
import { usePathname, useRouter, useSearchParams } from "next/navigation";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useTag } from "@/hooks/useTag";

export function VideosFilter() {
  const router = useRouter();
  const pathname = usePathname();
  const search = useSearchParams();
  const { tags, error, loading } = useTag();

  const setSearchParams = useCallback((filters: string[]) => {
    const params = new URLSearchParams();
    filters.map((c) => params.append("tagIds", c));
    router.replace(pathname + `?${params.toString()}`);
  }, []);

  const filters = search.getAll("tagIds") || [];

  if (error) return null;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild disabled={loading}>
        <Button
          variant="ghost"
          className="flex items-center gap-2 max-md:px-1 relative"
          disabled={loading}
        >
          <FilterIcon size={16} />
          {!!filters.length && (
            <span className="absolute rounded-full bg-primary right-1 top-1 text-[10px] text-white px-1 font-bold min-w-3.5 h-3.5 leading-none flex items-center justify-center">
              {filters.length}
            </span>
          )}
          Шүүлтүүр
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56" align="end">
        {tags.map((c, idx) => {
          const tagId = c.id.toString();
          return (
            <DropdownMenuCheckboxItem
              key={idx}
              checked={filters.includes(tagId)}
              iconPosition="end"
              onCheckedChange={() =>
                setSearchParams(
                  filters.includes(tagId)
                    ? filters.filter((cc) => cc !== tagId)
                    : [...filters, tagId]
                )
              }
            >
              {c.name}
            </DropdownMenuCheckboxItem>
          );
        })}
        {!!filters.length && (
          <>
            <DropdownMenuSeparator className="h-[1px] mb-4 mt-2 bg-slate-100" />
            <DropdownMenuItem
              onClick={() => router.replace(pathname)}
              className="py-1.5 px-2 text-center text-xs bg-destructive text-white rounded-md"
            >
              Арилгах
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
